import { Article, DocsHeader, DocsHeading, DocsIntro, Image, Section, SectionHeader } from '../extra/Components';
import {
    faBox,
} from "@fortawesome/free-solid-svg-icons";

import packning from '../assets/8 packning/packning-small.jpg';
import packning_small from '../assets/8 packning/packning-small.jpg';
import kontroll from '../assets/8 packning/3 kontroll-small.jpg';


const packningManualer = <Section id="manualer" name="Manualer">
    <SectionHeader>Manualer</SectionHeader>
    <p>Tillverkare har manualer sin utrustning. Uppstår det tveksamheter eller diskussion är det
        manualen som bestämmer vad som är rätt.</p>

    <a href="https://www.performancedesigns.com/products/navigator/" target="_blank"
        rel="noopener noreferrer">Performance designs Navigator produktsida. Har länk till generell
        manual.</a>
    <br /><br />
    <a href="https://www.performancedesigns.com/products/pdreserve/" target="_blank"
        rel="noopener noreferrer">Performance designs Reserve produktsida. Har länk till generell
        manual.</a>
    <br /><br />
    <a href="https://www.sunpath.com/support/manuals/" target="_blank"
        rel="noopener noreferrer">Sunpath manual</a>
    <br /><br />
    <a href="https://www.cypres.aero/documents/manuals/" target="_blank"
        rel="noopener noreferrer">AADn Airtech cypress 2 manualer</a>
</Section>;

const packningIntro = <DocsIntro>
    <Image image={packning} imageSmall={packning_small} alt="Packning" />

    <p>När hoppet är färdig återstår bara att återställa utrustningen. Valen är att antingen
        hitta någon som är villig att göra det mot betalning eller packa själv. Det ställs krav
        på att man ska kunna packa själv till högre certifikat. Det finns heller inte alltid
        packare. Vi hoppar med fallskärmar från tillverkaren Performance designs. Innan man har
        packcert ska tre kontroller genomföras under packningen. De beskrivs i nästa avsnitt.
        Bästa tillfället att lära sig packa är efter hoppningen avslutat för dagen utan stress
        be någon erfaren packare eller någon din instruktör tipsar om packa och visa en
        packning. Det görs oftast i utbyte mot att du betalar packningen om det är din fallskärm
        eller bara av godheten utav den som visar.</p>
    <p>Nedan finns videos där tillverkaren visar hur att packa en fallskärm in i bagen.</p>

    <a href="https://www.youtube.com/watch?v=5JiAegc8EOw" target="_blank"
        rel="noopener noreferrer">Performance designs packning del 1</a>
    <br />
    <a href="https://www.youtube.com/watch?v=qyM_LkW8DVI" target="_blank"
        rel="noopener noreferrer">Performance designs packning del 2</a>
    <br />
    <br />
    <p>Tillverkaren av våra elevriggar heter Sunpath och visar nedan hur man stoppar in bagen i
        riggen.</p>

    <a href="https://www.youtube.com/watch?v=wMBhC88p4Tk" target="_blank"
        rel="noopener noreferrer">Sunpath stänger en rigg</a>
</DocsIntro>;

const packingKontroller = <Section id="kontroller" name="Kontroller">
    <SectionHeader>Kontroller</SectionHeader>
    <Image image={kontroll} alt="Packning" />

    <p>När du packar utan packcert ska nedan kontroller utföras utav någon med
        fallskärmspackarbehörighet. Du behöver inte förstå var alla delar betyder men kan alltid be
        den som gör kontrollen förklara vad de kollar.</p>
    <ol>
        <li>
            Kontroll 1, när skärmen är rensad
            <ul>
                <li>Bromsarna är rätt satta</li>
                <li>Styrlineslacket rätt satt</li>
                <li>Bärremmarna är lika långa från vikten.</li>
                <li>Bromslinorna är otvinnade</li>
                <li>Följ styrlinorna upp för att se skärmen är rättvänd. Om vikt på bärremmarna
                    kolla att det inte är vrängt under vikten</li>
                <li>Linorna är centrerade och tyget utfläkt. Räkna rätt antal linor i alla
                    lingrupper. Var observant på linorna som sitter i stabilisatorerna</li>
                <li>Slidern är avkollapsad</li>
                <li>Slidern är korsad och mot sliderstoppen utan linor runt sig</li>
                <li>Kanten är utfläkt</li>
                <li>Eventuellt ge bakkanten till den som packar</li>
                <li>Hjälp lägga ner om det behövs</li>
            </ul>
        </li>
        <li>Kontroll 2, när skärmen är bag-ad och linslagen gjorda
            <ul>
                <li>Lagom med slack i alla slag och symmetriskt</li>
                <li>Linorna inte är trasslade/korsade</li>
                <li>Dubbelslag där det ska vara</li>
                <li>Lagom med slack till bärremmarna</li>
                <li>Piloten är avkollapsad</li>
                <li>Öljetten och metallringen på pilotlinefästet inte har tyg mellan sig för system
                    utan kollapsbar pilot.</li>
                <li>Bromsarna är rätt satta nu också</li>
                <li>Lyft baggen med båda händer till nedanför riggen.</li>
            </ul>
        </li>
        <li>
            Kontroll 3, när hela system är färdigpackat
            <ul>
                <li>Tre ringar. Tyg, metall, tyg, metall, loop. Loopen genom ändstycket på
                    hard-housingen kutt-vajer genom loop och hel</li>
                <li>Kuttvajer går från hard-housing till hard-housing</li>
                <li>RSL-skothaken sitter i</li>
                <li>Bröstremmen är hel</li>
                <li>Kutthandtag sitter</li>
                <li>Reservhandtag sitter</li>
                <li>Benremmar hela, kardeler hela</li>
                <li>Benremmar låser och rätt trädda</li>
                <li>Reservsprint hela vägen i</li>
                <li>Reservsprint plomberad</li>
                <li>RSL-lina rätt kopplad till reservsprinten</li>
                <li>Collins line yard rätt trädd om sådant system. Endast gult band om sådant</li>
                <li>(Reservhandtagslinan/vajern löper fritt i sitt housing)</li>
                <li>Huvudsprint, lagom looptryck</li>
                <li>Sprinten hela vägen in</li>
                <li>Loop gott skick</li>
                <li>Pilotlina rätt trädd</li>
                <li>Piloten lagom långt in i fickan</li>
                <li>Pilotfickkutt är trädd rätt ifall elevsystem</li>
            </ul>
        </li>
    </ol>
    <p>
        Tre kontroller. Första efter rensning. Andra efter bagging och slag. Tredje när allt är
        färdigt.
    </p>
</Section>;


const Packning = ({ setSection, setArticle }) => (
    <Article name="Packning" icon={faBox} id="packning" setArticle={setArticle} setSection={setSection}>
        <DocsHeader>
            <DocsHeading note="Updaterad: 2022-07-13">Packning</DocsHeading>
            {packningIntro}
        </DocsHeader>
        {packningManualer}
        {packingKontroller}
    </Article>
);

export {Packning , packningIntro, packningManualer, packingKontroller};